import { STOP_LOADING, START_LOADING } from '../types/loading'

const initState = {
  loading: false,
}

const loadingReducer = (state = initState, action = {}) => {
  const { type } = action

  switch (type) {
    case STOP_LOADING:
      return { loading: false }
    case START_LOADING:
      return { loading: true }
    default:
      return state
  }
}

export default loadingReducer



// WEBPACK FOOTER //
// ./src/reducers/loading.js